// extracted by mini-css-extract-plugin
export var icon_container = "icon_container-ubl";
export var statistic = "statistic-J8o";
export var with_heading = "with_heading-GXZ";
export var with_heading_and_description = "with_heading_and_description-Mcv";